import { IOverlay, PageNature, PageType } from '@makyoapp/makyo-sdk/models/AppBuilder'

import { DEFAULT_COMPONENTS_GROUPS } from '@/shared/builder'
import { BuilderOverlay } from '@/shared/overlay'

import { fromSdkActions, toSdkActions } from './BuilderActionAdapter'
import { fromSdkPageBody, toSdkPageBody } from './BuilderPageAdapter'

export function fromSdkOverlay(overlay: IOverlay): BuilderOverlay {
  return {
    id: overlay._id,
    tableId: overlay._TableID,
    actions: fromSdkActions(overlay._Actions),
    closeBehavior: overlay._CloseBehavior,
    placement: overlay._Placement,
    opacity: overlay._Opacity,
    elements: fromSdkPageBody(overlay._Body ?? [], DEFAULT_COMPONENTS_GROUPS),
    elementSettings: overlay._BodySettings || {},
    visibility: {
      isAny: overlay._Behavior?._Visibility?._Type !== 'all',
      conditions: [],
    },
    enabled: overlay._Enabled,
    title: overlay._Settings._Title,
    bgColor: overlay._Settings._BackgroundColor,
    icon: overlay._Settings._Icon?.value,
    shape: overlay._Shape,
    slug: overlay._Slug,
    type: overlay._Settings._Type,
    visible: overlay._IsVisible,
    size: overlay._Size,
    nature: overlay._Nature,
    alignment: (overlay._Settings._Alignment ?? 'center') as any
  }
}

export function fromSdkOverlayList(overlays: IOverlay[]): BuilderOverlay[] {
  return overlays.map(fromSdkOverlay)
}

export function toSdkOverlayList(overlays: BuilderOverlay[]): IOverlay[] {
  return overlays.map(toSdkOverlay)
}

export function toSdkOverlay(overlay: BuilderOverlay): IOverlay {
  return {
    _id: overlay.id,
    _TableID: overlay.tableId,
    _Enabled: overlay.enabled,
    _Settings: {
      _BackgroundColor: overlay.bgColor,
      _Title: overlay.title,
      _Icon: { value: overlay.icon },
      _Type: PageType.Standard,
      _Alignment: overlay.alignment,
    },
    _Body: toSdkPageBody(overlay.elements),
    _BodySettings: overlay.elementSettings,
    _Actions: toSdkActions(overlay.actions),
    _Behavior: {
      _Metadata: {},
      _Visibility: overlay.visibility,
    },
    _Slug: overlay.slug ?? '',
    _IsList: false,
    _CloseBehavior: overlay.closeBehavior as any,
    _IsVisible: overlay.visible,
    _Opacity: overlay.opacity,
    _Placement: overlay.placement as any,
    _Shape: overlay.shape,
    _Size: overlay.size,
    _Type: '',
    _Nature: overlay.nature ?? PageNature.Standard,
  }
}
